import { useCallback, useState } from 'react'

import { useGet } from '../../../../hooks/apiHooks'
import { config } from '../../../Init/Init'
import { tokenizer } from '../../../../services/utils'

export const useGetCryptoCurrencyExchangeRate = () => {
  const [exchangeRate, setExchangeRate] = useState({
    expirationDate: 0,
    from: '',
    price: 0,
    to: ''
  })

  const { GET, isLoading: isExchangeRateLoading } = useGet()

  const getCryptoCurrencyExchangeRate = useCallback(
    ({ from, to }) => {
      GET(
        config.paymentsUrl +
          tokenizer(config.getCryptoExchangeRateUrl, {
            '{from}': from,
            '{to}': to
          })
      )
        .then(data => {
          setExchangeRate(data)
        })
        .catch(error => console.log(error))
    },
    [GET]
  )

  return { getCryptoCurrencyExchangeRate, exchangeRate, isExchangeRateLoading }
}
